export enum CalendarPlatformIdentifier {
  GOOGLE_CALENDAR = "GOOGLE CALENDAR",
}
